export default "__VITE_ASSET__0TPpiph9__"